import { get } from 'lodash';
import React from 'react';
import SafeHtmlElements from '../SafeHtmlElements/SafeHtmlElements';
import commaFunction from '../../../utility/addCommaToNumbers/commaFunction';

const generateSafeCell = (
  key,
  placeHolder = '--',
  precision = 1,
  addCommas = false,
  fixedTrailingPoints = null,
  handleClick = () => {},
  className = null,
  unitKey = null,
  arraySeparator = ', ',
) =>
  function DataTableSafeCell(rowData) {
    const rawValue = get(rowData, key, null);
    const unit = unitKey && rawValue ? get(rowData, unitKey, null) : null;

    let formattedValue = rawValue;

    if (typeof formattedValue === 'string' && formattedValue.trim() === '') {
      formattedValue = null;
    }

    if (formattedValue !== null && addCommas) {
      formattedValue = commaFunction(formattedValue, precision);
    }

    const displayValue =
      formattedValue !== null && unit
        ? `${formattedValue} ${unit}`
        : formattedValue;

    return (
      <SafeHtmlElements
        tagName="span"
        precision={precision}
        placeholder={placeHolder}
        dataTestId={key}
        arraySeparator={arraySeparator}
        fixedTrailingPoints={fixedTrailingPoints}
        onClick={() => handleClick(rawValue)}
        className={className}
      >
        {displayValue}
      </SafeHtmlElements>
    );
  };

export const generateSafeCellWithUnit = ({
  valueKey,
  unitKey,
  placeHolder = '--',
  precision = 2,
  addCommas = false,
  fixedTrailingPoints = null,
  handleClick = () => {},
  className = null,
}) =>
  function DataTableSafeCellWithUnit(rowData) {
    let value = get(rowData, valueKey, null);
    const unit = get(rowData, unitKey, null);

    if (typeof value === 'string' && value.trim() === '') {
      value = null;
    }

    if (value !== null && addCommas) {
      value = commaFunction(value, precision);
    }

    const displayValue = value !== null && unit ? `${value} ${unit}` : value;

    return (
      <SafeHtmlElements
        tagName="span"
        precision={precision}
        placeholder={placeHolder}
        dataTestId={valueKey}
        fixedTrailingPoints={fixedTrailingPoints}
        onClick={() => handleClick(value)}
        className={className}
      >
        {displayValue}
      </SafeHtmlElements>
    );
  };

export default generateSafeCell;
